import { useMemo } from 'react';
import { number, object, ref, string } from 'yup';

export const getMediciensValidationSchema = (t) => useMemo(() => object().shape({
	name: string().required(t('MEDICIENS.VALIDATION.NAME_REQUIRED')),
	genericName: string().required(t('MEDICIENS.VALIDATION.GENERIC_NAME_REQUIRED')),
	description: string().optional().nullable(),
	type: string().required(t('MEDICIENS.VALIDATION.TYPE_REQUIRED')),
	minAge: number().required(t('MEDICIENS.VALIDATION.MIN_AGE_REQUIRED')).min(0, t('MEDICIENS.VALIDATION.MIN_AGE_MIN')),
	maxAge: number().required(t('MEDICIENS.VALIDATION.MAX_AGE_REQUIRED')).min(ref('minAge'),  t('MEDICIENS.VALIDATION.MAX_AGE_MIN')),
	status: string().required(t('MEDICIENS.VALIDATION.STATUS_REQUIRED')),
}), [t]);
